/* Amazon landing page (al-*): Amazon clickout + tracking, page interactions, video stories.
   Reads #amzb-config (al-hero section) and #story-data (al-stories section). */

/* ---------- 1. Amazon clickout + tracking ---------- */
(function () {
  'use strict';
  var cfg;
  try { cfg = JSON.parse(document.getElementById('amzb-config').textContent); } catch (e) { return; }
  var qs = new URLSearchParams(location.search);

  // gallery counter + thumbnails
  var track = document.querySelector('.track'), gIdx = document.querySelector('[data-g-index]');
  var thumbs = Array.prototype.slice.call(document.querySelectorAll('.thumbs button'));
  function setActive(i) {
    if (gIdx) gIdx.textContent = String(i + 1);
    thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
  }
  if (track) {
    var gt;
    track.addEventListener('scroll', function () { clearTimeout(gt); gt = setTimeout(function () { setActive(Math.round(track.scrollLeft / Math.max(track.clientWidth, 1))); }, 60); }, { passive: true });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { var i = Number(t.getAttribute('data-go')); track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); setActive(i); }); });
  }

  // price (only when set)
  var pr = document.querySelector('[data-price]');
  if (pr && Number(cfg.price) > 0) {
    pr.querySelector('[data-price-now]').textContent = '$' + Number(cfg.price).toFixed(2);
    pr.hidden = false;
  }

  // tracking ID (US Associates tags end in -20)
  var TAG_RE = /^[a-z0-9][a-z0-9-]{0,38}-20$/;
  var fallbackTag = String(cfg.fallbackTag || '').trim().toLowerCase();
  var allow = (cfg.allowlist || []).map(function (s) { return String(s).trim().toLowerCase(); }).filter(Boolean);
  allow.push(fallbackTag);
  var rawTid = (qs.get('tid') || '').trim().toLowerCase();
  var tid = (rawTid && TAG_RE.test(rawTid) && allow.indexOf(rawTid) > -1) ? rawTid : fallbackTag;
  function clean(v) { return String(v || '').replace(/[^\w.\-]/g, '').slice(0, 64); }
  var src = clean(qs.get('src') || qs.get('utm_source'));
  var plc = clean(qs.get('plc') || qs.get('utm_campaign'));
  // ad URL parameters passed into the Buy Now click events
  var utm = {};
  ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'placement', 'audience_type'].forEach(function (k) {
    var v = qs.get(k); if (v && v.indexOf('{{') < 0) utm[k] = String(v).slice(0, 100);
  });

  function detectOs() {
    var ua = navigator.userAgent || '';
    if (/Android/i.test(ua)) return 'android';
    if (/iPhone|iPad|iPod/i.test(ua) || (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1)) return 'ios';
    return 'other';
  }
  var os = detectOs();

  function getCookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/[.$?*|{}()[\]\\/+^]/g, '\\$&') + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  }
  function setCookie(name, value, days) {
    var host = location.hostname.replace(/^www\./, '');
    var domain = /\./.test(host) ? '; domain=.' + host : '';
    document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + new Date(Date.now() + days * 864e5).toUTCString() +
      '; path=/' + domain + '; SameSite=Lax' + (location.protocol === 'https:' ? '; Secure' : '');
  }
  var fbclid = qs.get('fbclid');
  if (fbclid && !getCookie('_fbc')) setCookie('_fbc', 'fb.1.' + Date.now() + '.' + fbclid, 90);

  function uuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) { var r = Math.random() * 16 | 0; return (c === 'x' ? r : (r & 3 | 8)).toString(16); });
  }

  if (cfg.loadPixel && cfg.pixelId && !window.fbq) {
    !function (f, b, e, v, n, t, s) {
      if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
      if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0'; n.queue = [];
      t = b.createElement(e); t.async = !0; t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    window.fbq('init', String(cfg.pixelId));
    if (cfg.firePageView) window.fbq('track', 'PageView');
  }
  function pixel(kind, name, data, eventId) {
    if (typeof window.fbq !== 'function') return;
    try { window.fbq(kind, name, data, { eventID: eventId }); } catch (e) {}
  }
  function server(name, data, eventId) {
    if (!cfg.endpoint) return;
    var body = { event_name: name, event_id: eventId, event_source_url: location.href, fbp: getCookie('_fbp') || undefined, fbc: getCookie('_fbc') || undefined, custom_data: data };
    var payload = JSON.stringify(body), sent = false;
    try { if (navigator.sendBeacon) sent = navigator.sendBeacon(cfg.endpoint, new Blob([payload], { type: 'text/plain' })); } catch (e) {}
    if (!sent) { try { fetch(cfg.endpoint, { method: 'POST', body: payload, keepalive: true, mode: 'no-cors', headers: { 'Content-Type': 'text/plain' } }); } catch (e) {} }
  }
  function gaPush(name, data) {
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, data)); } catch (e) {}
  }

  var asin = String(cfg.asin || '').trim().toUpperCase();
  var value = Number(cfg.price) || 0;
  var contentId = asin || String(cfg.sku || '');
  var baseData = { content_ids: [contentId], content_type: 'product', value: value, currency: cfg.currency || 'USD' };

  var vcId = uuid();
  pixel('track', 'ViewContent', baseData, vcId);
  var vcSent = false;
  function sendVc() { if (vcSent) return; vcSent = true; server('ViewContent', baseData, vcId); }
  if (document.readyState === 'complete') setTimeout(sendVc, 300);
  else { window.addEventListener('load', function () { setTimeout(sendVc, 300); }); setTimeout(sendVc, 3000); }
  gaPush('view_item', { product_name: cfg.productName, product_id: contentId, page_url: location.href });

  // Amazon links (web link everywhere, app intent on Android)
  var rawParams = String(cfg.linkParams || '').replace(/^[?&]+/, '');
  // keep an Amazon Attribution tag (tag=maas) unless an Associates tag replaces it
  var params = tid ? rawParams.replace(/(^|&)tag=[^&]*/g, '').replace(/^&+/, '') : rawParams;
  var tagPart = tid ? 'tag=' + encodeURIComponent(tid) : '';
  var query = [tagPart, params].filter(Boolean).join('&');
  var path = asin
    ? 'www.amazon.com/dp/' + encodeURIComponent(asin) + (query ? '?' + query : '')
    : 'www.amazon.com/s?' + ['k=' + encodeURIComponent(cfg.searchFallback || cfg.productName), query].filter(Boolean).join('&');
  var webLink = 'https://' + path;
  var intentLink = 'intent://' + path + '#Intent;scheme=https;package=' + String(cfg.androidPackage) +
    ';S.browser_fallback_url=' + encodeURIComponent(webLink) + ';end';
  var targetLink = os === 'android' ? intentLink : webLink;

  function deviceType() {
    var w = Math.min(window.screen && screen.width || window.innerWidth, window.innerWidth);
    if (os === 'other' && w >= 1024) return 'desktop';
    return w >= 768 ? 'tablet' : 'mobile';
  }

  var fired = false, lastGa = 0;
  Array.prototype.forEach.call(document.querySelectorAll('[data-amzb-buy]'), function (btn) {
    btn.setAttribute('href', webLink);
    btn.addEventListener('click', function (e) {
      if (window.Shopify && Shopify.designMode) { e.preventDefault(); return; }
      e.preventDefault();
      var loc = clean(btn.getAttribute('data-cta-location')) || 'main';
      var now = Date.now();
      if (now - lastGa > 1000) {
        lastGa = now;
        gaPush('amazon_product_click', Object.assign({ product_name: cfg.productName, product_id: contentId, cta_location: loc, page_url: location.href, device_type: deviceType(), tid: tid }, utm));
      }
      if (!fired) {
        fired = true;
        btn.setAttribute('aria-busy', 'true');
        setTimeout(function () { btn.removeAttribute('aria-busy'); }, 1500);
        var id = uuid();
        var data = Object.assign({}, baseData, utm, { tid: tid, src: src, plc: plc, os: os, cta_location: loc });
        pixel('trackCustom', 'AmazonClickout', data, id);
        server('AmazonClickout', data, id);
      }
      window.location.href = targetLink;
    });
  });

  Array.prototype.forEach.call(document.querySelectorAll('[data-amzb-faq]'), function (d) {
    d.addEventListener('toggle', function () { if (d.open) gaPush('faq_open', { question: d.querySelector('summary').textContent.trim().slice(0, 100) }); });
  });

  var marks = [25, 50, 75, 100], hit = {};
  window.addEventListener('scroll', function () {
    var h = document.documentElement, pct = (h.scrollTop + window.innerHeight) / h.scrollHeight * 100;
    marks.forEach(function (m) { if (pct >= m && !hit[m]) { hit[m] = 1; gaPush('scroll_depth', { percent: m }); } });
  }, { passive: true });

  // promo code per tracking ID
  var code = (cfg.promo || {})[tid];
  var promo = document.querySelector('[data-amzb-promo]');
  if (promo && code) {
    promo.querySelector('[data-amzb-code]').textContent = code;
    promo.hidden = false;
    var copyBtn = promo.querySelector('[data-amzb-copy]');
    copyBtn.addEventListener('click', function () {
      function done() { copyBtn.textContent = 'Copied'; setTimeout(function () { copyBtn.textContent = 'Copy code'; }, 2000); }
      function fallbackCopy() {
        var ta = document.createElement('textarea'); ta.value = code; ta.setAttribute('readonly', '');
        ta.style.position = 'fixed'; ta.style.opacity = '0'; document.body.appendChild(ta); ta.select();
        try { document.execCommand('copy'); done(); } catch (e) {} document.body.removeChild(ta);
      }
      if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(code).then(done, fallbackCopy); else fallbackCopy();
    });
  }
})();

/* ---------- 2. Page interactions ---------- */
(function () {
  'use strict';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var IO = 'IntersectionObserver' in window;

  // header button + bottom Buy bar hide while any section Buy Now is on screen
  var sticky = document.querySelector('[data-amzb-sticky]'), top = document.querySelector('[data-top]') || document.createElement('div');
  var inPage = Array.prototype.filter.call(document.querySelectorAll('[data-amzb-buy]'), function (b) {
    var l = b.getAttribute('data-cta-location'); return l !== 'sticky' && l !== 'header' && l !== 'story';
  });
  var seen = new Set();
  function syncSticky() {
    var show = seen.size === 0;
    sticky.classList.toggle('is-visible', show);
    sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
    Array.prototype.forEach.call(sticky.querySelectorAll('a'), function (a) { a.tabIndex = show ? 0 : -1; });
    top.classList.toggle('cta-hidden', !show);
  }
  if (IO && sticky && inPage.length) {
    var ioCta = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) seen.add(e.target); else seen.delete(e.target); });
      syncSticky();
    }, { rootMargin: '-60px 0px -90px 0px' });
    inPage.forEach(function (b) { ioCta.observe(b); });
    seen.add(inPage[0]); syncSticky();
  } else if (sticky) { sticky.classList.add('is-visible'); }

  // reading progress
  var bar = document.querySelector('[data-progress]') || document.createElement('i'), ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return; ticking = true;
    requestAnimationFrame(function () {
      var h = document.documentElement, p = h.scrollTop / Math.max(h.scrollHeight - innerHeight, 1);
      bar.style.transform = 'scaleX(' + Math.min(1, p).toFixed(4) + ')'; ticking = false;
    });
  }, { passive: true });

  // ripple on buttons
  Array.prototype.forEach.call(document.querySelectorAll('.btn'), function (btn) {
    btn.addEventListener('pointerdown', function (e) {
      if (reduce) return;
      var r = btn.getBoundingClientRect(), d = Math.max(r.width, r.height), s = document.createElement('span');
      s.className = 'rip'; s.style.width = s.style.height = d + 'px';
      s.style.left = (e.clientX - r.left - d / 2) + 'px'; s.style.top = (e.clientY - r.top - d / 2) + 'px';
      btn.appendChild(s); setTimeout(function () { s.remove(); }, 650);
    });
  });

  // hero Buy Now nudges once after a few seconds
  var hero = document.querySelector('[data-cta-location="hero"]');
  if (hero && !reduce) setTimeout(function () { hero.classList.add('nudge'); setTimeout(function () { hero.classList.remove('nudge'); }, 1100); }, 4500);

  // scroll reveal (failsafe shows everything after 6s)
  var rvs = Array.prototype.slice.call(document.querySelectorAll('.rv'));
  if (IO && !reduce && !(window.Shopify && Shopify.designMode)) {
    document.documentElement.classList.add('js-rv');
    var vh = innerHeight;
    rvs.forEach(function (el) { if (el.getBoundingClientRect().top < vh) el.classList.add('in'); });
    var ioR = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); ioR.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    rvs.forEach(function (el) { if (!el.classList.contains('in')) ioR.observe(el); });
    ['.bens > li', '.rail > li', '.why > li', '.proof > div', '.games > li', '.steps > li'].forEach(function (q) {
      Array.prototype.forEach.call(document.querySelectorAll(q), function (c, i) { c.style.transitionDelay = (i * 70) + 'ms'; });
    });
    setTimeout(function () { rvs.forEach(function (el) { el.classList.add('in'); }); }, 6000);
  }

  // count-up numbers and rating bars
  function countUp(el) {
    var end = Number(el.getAttribute('data-count')), t0 = null;
    if (reduce || !end) { el.textContent = String(end); return; }
    function step(t) { if (!t0) t0 = t; var p = Math.min((t - t0) / 1200, 1), e = 1 - Math.pow(1 - p, 3);
      el.textContent = String(Math.round(end * e)); if (p < 1) requestAnimationFrame(step); }
    requestAnimationFrame(step);
  }
  var bars = document.querySelector('[data-bars]');
  if (IO) {
    var ioC = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (!e.isIntersecting) return; ioC.unobserve(e.target);
        if (e.target === bars) bars.classList.add('in'); else countUp(e.target); });
    }, { threshold: .6 });
    Array.prototype.forEach.call(document.querySelectorAll('[data-count]'), function (el) { ioC.observe(el); });
    if (bars) ioC.observe(bars);
  } else if (bars) bars.classList.add('in');

  // gallery auto-advance until the visitor touches it
  var track = document.querySelector('.track'), auto = null;
  if (track && !reduce && track.children.length > 1) {
    var n = track.children.length;
    auto = setInterval(function () {
      var r = track.getBoundingClientRect(); if (r.bottom < 0 || r.top > innerHeight) return;
      var i = (Math.round(track.scrollLeft / track.clientWidth) + 1) % n;
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    }, 4200);
    ['pointerdown', 'wheel', 'touchstart', 'keydown'].forEach(function (ev) {
      track.addEventListener(ev, function () { clearInterval(auto); }, { passive: true });
    });
    Array.prototype.forEach.call(document.querySelectorAll('.thumbs button'), function (b) { b.addEventListener('click', function () { clearInterval(auto); }); });
  }

  function paint(r) { r.style.setProperty('--p', ((r.value - r.min) / (r.max - r.min) * 100) + '%'); }

  // fit checker (inches); product footprint comes from the section settings
  var fw = document.getElementById('fitW'), fl = document.getElementById('fitL');
  var spot = document.getElementById('spotRect'), cab = document.getElementById('cabG'), lab = document.getElementById('spotLabel'), v = document.getElementById('fitV');
  var tool = document.querySelector('[data-fit]');
  var CW = tool ? Number(tool.getAttribute('data-cab-w')) || 18.82 : 18.82, CD = tool ? Number(tool.getAttribute('data-cab-d')) || 22.44 : 22.44;
  var MSG_OK = (tool && tool.getAttribute('data-msg-ok')) || 'It fits, with room for the plug and to stand back.';
  var MSG_SNUG = (tool && tool.getAttribute('data-msg-snug')) || 'It fits, but it’s snug. Leave a few inches behind for the power cord.';
  var used = false;
  function fit() {
    var w = Number(fw.value), l = Number(fl.value);
    document.getElementById('fitWo').textContent = w + ' in';
    document.getElementById('fitLo').textContent = l + ' in';
    paint(fw); paint(fl);
    var sc = 150 / Math.max(w, l, CD + 2), sw = w * sc, sl = l * sc;
    spot.setAttribute('x', -sw / 2); spot.setAttribute('y', -sl / 2); spot.setAttribute('width', sw); spot.setAttribute('height', sl);
    cab.setAttribute('x', -CW * sc / 2); cab.setAttribute('y', -CD * sc / 2); cab.setAttribute('width', CW * sc); cab.setAttribute('height', CD * sc);
    lab.textContent = 'Your spot: ' + w + ' × ' + l + ' in';
    if (w >= CW + 3 && l >= CD + 3.5) { v.className = 'fit-verdict ok'; v.innerHTML = '<span aria-hidden="true">✓</span>'; v.appendChild(document.createTextNode(MSG_OK)); cab.setAttribute('fill', '#0D1016'); }
    else if (w >= CW && l >= CD) { v.className = 'fit-verdict warn'; v.innerHTML = '<span aria-hidden="true">!</span>'; v.appendChild(document.createTextNode(MSG_SNUG)); cab.setAttribute('fill', '#0D1016'); }
    else { v.className = 'fit-verdict warn'; v.innerHTML = '<span aria-hidden="true">✕</span>Too tight. It needs about ' + Math.ceil(CW) + ' × ' + Math.ceil(CD) + ' in of floor.'; cab.setAttribute('fill', '#F00078'); }
    if (!used) { used = true; try { (window.dataLayer = window.dataLayer || []).push({ event: 'fit_checker_used' }); } catch (e) {} }
  }
  if (fw && fl && spot && cab) { fw.addEventListener('input', fit); fl.addEventListener('input', fit); used = true; fit(); used = false; }

  // pixel starfield in the hero
  var sf = document.querySelector('[data-stars]');
  if (sf) { for (var k = 0; k < 28; k++) { var st = document.createElement('i');
    st.style.left = (Math.random() * 100).toFixed(1) + '%'; st.style.top = (Math.random() * 100).toFixed(1) + '%';
    st.style.animationDelay = (Math.random() * 3).toFixed(2) + 's'; sf.appendChild(st); } }

  // game library filter
  var games = Array.prototype.slice.call(document.querySelectorAll('.game'));
  Array.prototype.forEach.call(document.querySelectorAll('[data-filter]'), function (btn, i, all) {
    btn.addEventListener('click', function () {
      var f = btn.getAttribute('data-filter');
      Array.prototype.forEach.call(all, function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
      games.forEach(function (g) {
        var show = f === 'all' || g.getAttribute('data-cat') === f;
        g.classList.toggle('is-hidden', !show);
        if (show && !reduce) { g.classList.remove('flash'); void g.offsetWidth; g.classList.add('flash'); }
      });
      try { (window.dataLayer = window.dataLayer || []).push({ event: 'game_filter', filter: f }); } catch (e) {}
    });
  });

  // hide the logo if it fails to load
  var logo = document.querySelector('.logo img');
  if (logo) { logo.addEventListener('error', function () { logo.hidden = true; }); if (logo.complete && !logo.naturalWidth) logo.hidden = true; }
})();

/* ---------- 3. Video stories (reels + full-screen viewer) ---------- */
(function () {
  'use strict';
  var el = document.getElementById('story-data');
  var data = []; try { data = JSON.parse(el ? el.textContent : '[]'); } catch (e) { return; }
  data = data.filter(function (d) { return d && d.src; });
  if (!data.length) return;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function ga(ev, p) { try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: ev }, p)); } catch (e) {} }
  var PLAY = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 4.5v15l13-7.5z"/></svg>';
  function esc(t) { var d = document.createElement('div'); d.textContent = t || ''; return d.innerHTML; }

  // reels with muted previews that play while on screen
  var reels = document.querySelector('[data-story-reels]');
  var previews = [];
  if (reels) data.forEach(function (d, i) {
    var r = document.createElement('button'); r.type = 'button'; r.className = 'reel'; r.setAttribute('aria-label', 'Play video: ' + d.title);
    r.innerHTML = '<span class="reel-ph">' + PLAY + '</span><img class="r-bg" alt=""><video muted playsinline loop preload="none"></video>' +
      '<span class="r-top"><span class="r-by"><b>' + esc(d.av || '1UP') + '</b>' + esc(d.by) + '</span><span class="r-dur">' + esc(d.dur) + '</span></span>' +
      '<span class="r-bot"><strong>' + esc(d.title) + '</strong><span class="r-play">' + PLAY + 'Watch</span></span>';
    var im = r.querySelector('img'); im.addEventListener('error', function () { im.hidden = true; }); if (d.poster) im.src = d.poster; else im.hidden = true;
    var v = r.querySelector('video'); if (d.poster) v.poster = d.poster; v.setAttribute('data-src', d.src);
    v.addEventListener('error', function () { v.hidden = true; });
    previews.push(v);
    r.addEventListener('click', function () { open(i, 'reel'); });
    reels.appendChild(r);
  });
  if (!reduce && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { var v = e.target;
        if (e.isIntersecting && !document.body.classList.contains('sv-lock')) { if (!v.src) v.src = v.getAttribute('data-src'); var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else v.pause(); });
    }, { threshold: .6 });
    previews.forEach(function (v) { io.observe(v); });
  }

  // viewer
  var sv = document.querySelector('[data-sv]'); if (!sv) return;
  document.body.appendChild(sv);
  var frame = sv.querySelector('[data-sv-frame]'), vid = sv.querySelector('[data-sv-vid]');
  var barsEl = sv.querySelector('[data-sv-bars]'), bg = sv.querySelector('[data-sv-bg]');
  var muteBtn = sv.querySelector('[data-sv-mute]');
  var cur = -1, muted = true, raf = 0, lastFocus = null, holdT = 0, held = false;
  barsEl.innerHTML = data.map(function () { return '<span><i></i></span>'; }).join('');
  var fills = barsEl.querySelectorAll('i');
  function paintBars() { Array.prototype.forEach.call(fills, function (f, k) { f.style.width = k < cur ? '100%' : '0%'; }); }
  function tick() { if (cur > -1 && vid.duration) fills[cur].style.width = (vid.currentTime / vid.duration * 100) + '%'; raf = requestAnimationFrame(tick); }
  function setMute(m) { muted = m; vid.muted = m; muteBtn.setAttribute('aria-label', m ? 'Unmute' : 'Mute');
    muteBtn.innerHTML = m ? '<svg viewBox="0 0 24 24"><path d="M11 5L6 9H3v6h3l5 4z"/><path d="M22 9l-6 6M16 9l6 6"/></svg>' : '<svg viewBox="0 0 24 24"><path d="M11 5L6 9H3v6h3l5 4z"/><path d="M15.5 8.5a5 5 0 0 1 0 7M18.5 5.5a9 9 0 0 1 0 13"/></svg>'; }
  function show(i) {
    if (i < 0) i = 0;
    if (i >= data.length) { close(); return; }
    cur = i; var d = data[i];
    frame.classList.remove('has-err', 'is-paused'); frame.classList.toggle('portrait', d.orient === 'portrait');
    bg.style.backgroundImage = d.poster ? 'url("' + d.poster + '")' : 'none';
    sv.querySelector('[data-sv-title]').textContent = d.title || '';
    sv.querySelector('[data-sv-by]').textContent = d.by || '';
    if (d.poster) vid.poster = d.poster; else vid.removeAttribute('poster');
    vid.src = d.src; vid.muted = muted; vid.currentTime = 0;
    var p = vid.play(); if (p && p.catch) p.catch(function () { if (!muted) { setMute(true); vid.play().catch(function () {}); } });
    paintBars(); ga('story_view', { story: d.id, index: i + 1 });
  }
  function open(i, from) {
    lastFocus = document.activeElement;
    previews.forEach(function (v) { v.pause(); });
    sv.classList.add('open'); sv.setAttribute('aria-hidden', 'false'); document.body.classList.add('sv-lock');
    setMute(false);
    show(i); cancelAnimationFrame(raf); raf = requestAnimationFrame(tick);
    ga('story_open', { from: from, story: data[i].id });
    setTimeout(function () { sv.querySelector('[data-sv-close]').focus(); }, 50);
  }
  function close() {
    sv.classList.remove('open'); sv.setAttribute('aria-hidden', 'true'); document.body.classList.remove('sv-lock');
    vid.pause(); vid.removeAttribute('src'); vid.load(); cancelAnimationFrame(raf); cur = -1;
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  vid.addEventListener('ended', function () { ga('story_complete', { story: data[cur] && data[cur].id }); show(cur + 1); });
  vid.addEventListener('error', function () { if (cur > -1 && vid.getAttribute('src')) frame.classList.add('has-err'); });
  sv.querySelector('[data-sv-close]').addEventListener('click', close);
  muteBtn.addEventListener('click', function () { setMute(!muted); });
  sv.querySelector('[data-sv-prev]').addEventListener('click', function () { show(cur - 1); });
  sv.querySelector('[data-sv-next]').addEventListener('click', function () { show(cur + 1); });
  function tapNav(dir) { return function () { if (held) { held = false; return; } show(cur + dir); }; }
  sv.querySelector('[data-sv-tapprev]').addEventListener('click', tapNav(-1));
  sv.querySelector('[data-sv-tapnext]').addEventListener('click', tapNav(1));
  Array.prototype.forEach.call(sv.querySelectorAll('.sv-tap'), function (t) {
    t.addEventListener('pointerdown', function () { holdT = setTimeout(function () { held = true; vid.pause(); frame.classList.add('is-paused'); }, 220); });
    ['pointerup', 'pointerleave', 'pointercancel'].forEach(function (ev) { t.addEventListener(ev, function () { clearTimeout(holdT); if (frame.classList.contains('is-paused')) { frame.classList.remove('is-paused'); vid.play().catch(function () {}); } }); });
  });
  var sx = 0, sy = 0;
  frame.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
  frame.addEventListener('touchend', function (e) { var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
    if (dy > 90 && Math.abs(dy) > Math.abs(dx)) close(); else if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy)) show(cur + (dx < 0 ? 1 : -1)); }, { passive: true });
  sv.addEventListener('click', function (e) { if (e.target === sv) close(); });
  document.addEventListener('keydown', function (e) { if (!sv.classList.contains('open')) return;
    if (e.key === 'Escape') close(); else if (e.key === 'ArrowRight') show(cur + 1); else if (e.key === 'ArrowLeft') show(cur - 1);
    else if (e.key === ' ') { e.preventDefault(); if (vid.paused) { vid.play().catch(function () {}); frame.classList.remove('is-paused'); } else { vid.pause(); frame.classList.add('is-paused'); } } });
  document.addEventListener('visibilitychange', function () { if (document.hidden && sv.classList.contains('open')) vid.pause(); });

  // any element with data-story-open="id" opens that video
  Array.prototype.forEach.call(document.querySelectorAll('[data-story-open]'), function (a) {
    a.addEventListener('click', function (e) { e.preventDefault(); var id = a.getAttribute('data-story-open');
      var i = data.findIndex(function (d) { return d.id === id; }); open(i < 0 ? 0 : i, 'link'); });
  });
})();
